import React from 'react';

class Events extends React.Component {
    componentDidMount() {

    }

    render() {
        var images = [
            './assets/images/events/events1.jpg',
            './assets/images/events/events2.jpg'
        ]
        var list = (images.map(function (item) {
            return <img src={item} class='bigimage' />;
        }));

        var newcomplete = (
            <div class='fullwidthcontainer'>
                <div class='fullwidthcontainer'>
                    {list}
                </div>
                <div class='fullwidthcontainer'>
                    <div class='text center'>
                        [Im Showroom werden ausgewählte und exklusive Events .....]
                    </div>
                </div>
            </div>
        );

        return newcomplete;
    }
}

export default (Events);